import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fed3c6d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fed3c6d')) {
      api.createRecord('2fed3c6d', component.options)
    } else {
      api.reload('2fed3c6d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fed3c6d", function () {
      api.rerender('2fed3c6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/sensitiveList/index.vue"
export default component.exports